import { render, staticRenderFns } from "./BaseImageDisplay.vue?vue&type=template&id=1db15045&scoped=true"
import script from "./BaseImageDisplay.vue?vue&type=script&lang=js"
export * from "./BaseImageDisplay.vue?vue&type=script&lang=js"
import style0 from "./BaseImageDisplay.vue?vue&type=style&index=0&id=1db15045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db15045",
  null
  
)

export default component.exports